import { Fragment, useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import Alert from '../../common/Alert.component';
import { saveAs } from 'file-saver';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress } from '@mui/material';
import _ from 'lodash';

const DownloadRows = ({
  module: { tag, query },
  label = 'Download',
  isCSV = false,
}) => {
  const {
    list
  } = useSelector((state) => state[tag]);
  const { jwt } = useSelector((state) => state.login);
  const userAuth = useSelector((state) => state.login?.user);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const hasPermissions = useMemo(
    () => userAuth.permissions[_.toUpper(tag)]?.DOWNLOAD_DOCUMENTS === 'true',
    [userAuth, tag]
  );

  const onError = useCallback((err) => {
    setSuccess(false);
    setLoading(false);
    setError(err?.message || 'An error has occurred');
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(
    (resp) => {
      const file = new Blob([resp?.data], {
        type: isCSV ? 'text/csv;charset=utf-8' : 'application/pdf',
      });
      let fileName = 'File';
      const contentDisposition = resp?.headers?.['content-disposition'];
      if (contentDisposition) {
        fileName = contentDisposition.match(/filename="?([^"]+)"?/)?.[1];
      }
      saveAs(file, fileName);
      setSuccess(true);
      setLoading(false);
      setError(false);
    },
    [setLoading, setSuccess, isCSV]
  );

  const onSubmit = useCallback(() => {
    const listId = list?.selected && Object.values(list?.selected).flat();
    setLoading(true);
    setError(false);
    setSuccess(false);

    fetchAPI(query.action.settings2, {}, '', { data: { ids: listId } }, jwt)
      .then((resp) => onSuccess(resp))
      .catch((err) => onError(err));
  }, [list?.selected, jwt, onError, onSuccess, query]);

  return (
    <Fragment>
      {success && <Alert severity='success'>{'Success: Download PDF'}</Alert>}
      {error && <Alert severity='error'>{error}</Alert>}

      {hasPermissions && (
        <Button
          onClick={onSubmit}
          variant='contained'
          size='small'
          sx={{ minWidth: 150 }}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} color='inherit' />
            ) : (
              <DownloadIcon />
            )
          }
        >
          {label}
        </Button>
      )}
    </Fragment>
  );
};

export default DownloadRows;
